/**
 * HABBY FUN 页面多语言
 * 未配置的语言回退到英文
 */
const funI18n = {
    en: {
        // PC：多行标题
        whoWeAre: 'Who\nWe\nAre',
        whoWeAreDesc:
            'Habby.FUN is a dedicated stage for PC and console players, born from a simple devotion to pure fun. Rooted in the spirit of "Craft," our focus spans across Steam and multi-platform ecosystems, bringing to life original games defined by unique artistry and innovative mechanics.',
        heartOverHype: 'HEART\nOVER\nHYPE',
        heartOverHypeDesc:
            'We believe that true joy and a sense of accomplishment should always spring directly from the gameplay experience itself. We are committed to fostering a fair, earnest, and surprising world for players. Through every sincere creation, our ultimate goal is to leave a lasting smile—our signature of joy—in your heart.',
        ourFunGames: 'Our\nFun\nGames',
        // Mobile：单行居中标题
        whoWeAreMo: 'Who We Are',
        heartOverHypeMo: 'HEART OVER HYPE',
        ourFunGamesMo: 'OUR FUN GAMES',
        comingSoon: 'Coming soon',
        contactLabel: 'Contact',
        contactEmail: 'support_pc@habby.com',
    },
    zh: {
        whoWeAre: '我们\n是谁',
        whoWeAreDesc:
            'Habby.fun 是专为 PC 与主机玩家构筑的全新舞台。秉持着“造物（Craft）”精神，我们聚焦于 Steam 与多平台生态，致力于孕育兼具独特美学与创新玩法的原创作品。',
        heartOverHype: '真心\n胜于\n浮华',
        heartOverHypeDesc:
            '出于对“纯粹乐趣”的向往，我们坚信，游戏带来的快乐与成就感，理应纯粹地回归游玩体验本身。我们渴望为玩家建立一个公平、真诚且充满惊喜的世界。通过每一部诚意之作，我们期盼能在你的心底，留下那一抹代表快乐的微笑。',
        ourFunGames: '我们的\n游戏',
        whoWeAreMo: '我们是谁',
        heartOverHypeMo: '真心胜于浮华',
        ourFunGamesMo: '我们的游戏',
        comingSoon: '即将上线',
        contactLabel: '联系邮箱',
        contactEmail: 'support_pc@habby.com',
    },
};

export function getFunI18n(lang) {
    return funI18n[lang] || funI18n.en;
}

export default funI18n;



// WEBPACK FOOTER //
// ./src/pages/fun/i18n.js